import { TFunction } from 'i18next'
import { z } from 'zod'

import { baseContentSchema } from '../shared/schemas'
import { BlockConfig } from '../shared/types'

const instagramEmbedContentSchema = baseContentSchema.merge(
  z.object({
    websiteUrl: z.string().optional(),
    html: z.string().optional(),
  }),
)

export type InstagramEmbedContentSchema = z.infer<
  typeof instagramEmbedContentSchema
>

export const instagramEmbedConfig = ({
  t,
}: {
  t: TFunction<'translation', undefined>
}): BlockConfig => ({
  kind: 'INSTAGRAM_EMBED',
  minW: 3,
  minH: 4,
  maxW: 4,
  maxH: 16,
  contentKey: 'instagramEmbedContent',
  schema: instagramEmbedContentSchema,
  name: t('instagram_embed'),
  examples: ['https://www.instagram.com/p/CaUsPbUquKV/'],
  description: t('embed_instagram_posts_to_enrich_your_page_content'),
  searchTags: [
    'instagram',
    'photos',
    'images',
    'social media',
    'embed',
    'iframe',
    'html',
    'embed the web',
  ],
})
